var map = {
	"./cholera.json": 1035,
	"./covid.json": 6268,
	"./dengue.json": 7037,
	"./diphtheria.json": 5341,
	"./enterovirus.json": 5033,
	"./flu_north.json": 8144,
	"./flu_south.json": 9890,
	"./hep_a.json": 2568,
	"./hep_b.json": 7429,
	"./hib.json": 6770,
	"./hpv.json": 7668,
	"./je.json": 1974,
	"./measles.json": 4915,
	"./meningococcal.json": 4153,
	"./mpox.json": 1589,
	"./mumps.json": 8749,
	"./pertussis.json": 7887,
	"./pneumococcal.json": 5602,
	"./polio.json": 4022,
	"./rabies.json": 2903,
	"./rotavirus.json": 6116,
	"./rsv.json": 7590,
	"./rubella.json": 758,
	"./shingles.json": 7024,
	"./smallpox.json": 5933,
	"./tb.json": 3881,
	"./tbe.json": 1416,
	"./tetanus.json": 3099,
	"./typhoid.json": 2308,
	"./varicella.json": 2502,
	"./yellow_fever.json": 9694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1258;